/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useDebounceFn } from '@client/hooks/use-debounce-fn';
import { InputAdornment, TextFieldProps } from '@mui/material';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faTimesCircle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { faLoader } from '@fortawesome/pro-regular-svg-icons';
import { TextField } from '../basic';

type LiveTextFieldProps = TextFieldProps & {
  isValid: (value: string) => Promise<[boolean, string?]>;
  debounceMs?: number;
  startAdornment?: React.ReactNode;
};
export function LiveTextField(props: LiveTextFieldProps) {
  const { debounceMs = 500 } = props;

  const [isValid, setIsValid] = React.useState(true);
  const [isValidating, setIsValidating] = React.useState(false);
  const [isValidated, setIsValidated] = React.useState(false);
  const [error, setError] = React.useState<string>('');
  const validationDebounce = useDebounceFn();

  const tapOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    validationDebounce(async () => {
      try {
        setIsValidating(true);
        const [validationResponse, error] = await props.isValid(value);
        setIsValid(validationResponse);
        setError(error ? error : '');
        setIsValidated(true);
        setIsValidating(false);
      } catch (e) {
        setIsValid(false);
        setIsValidated(true);
        setIsValidating(false);
      }
    }, debounceMs);

    props.onChange?.(e);
  };

  return (
    <TextField
      {...props}
      ref={props.ref as any}
      error={props.error || !isValid}
      onChange={tapOnChange}
      helperText={error || props.helperText}
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <span>{props.startAdornment}</span>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {isValidating ? (
              <Icon className="text-lg" icon={faLoader} />
            ) : isValidated ? (
              <Icon
                className="text-lg"
                icon={(isValid ? faCheckCircle : faTimesCircle) as any}
                color={isValid ? '#5FBC76' : '#FF7070'}
              />
            ) : null}
          </InputAdornment>
        ),
      }}
    />
  );
}
